<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Filter parked carts</ion-title>
    @if (online && !loading) {
      <ion-buttons slot="end">
        <ion-button (click)="clearFilters()">
          <fa-icon [icon]="['far', 'trash-alt']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
          <span>Clear</span>
        </ion-button>
        <ion-button (click)="filter()">
          <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (online && !loading) {
    <ion-grid class="form">
      <ion-row>
        <ion-col>
          <ion-grid class="fieldset">
            <ion-row>
              <ion-col>
                <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="timeframe_options" (ionCancel)="clearTimeframe()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['timeframe']">
                  <div slot="label">Timeframe<ion-text class="optional">optional</ion-text></div>
                  <ion-select-option value="today">Today</ion-select-option>
                  <ion-select-option value="yesterday">Yesterday</ion-select-option>
                  <ion-select-option value="this_week">This week (Mon-Sun)</ion-select-option>
                  <ion-select-option value="last_week">Last week (Mon-Sun)</ion-select-option>
                  <ion-select-option value="this_month">This month</ion-select-option>
                  <ion-select-option value="last_month">Last month</ion-select-option>
                  <ion-select-option value="custom">Custom</ion-select-option>
                </ion-select>
              </ion-col>
            </ion-row>
            @if (filter_params['timeframe'] == 'custom') {
              <ion-row>
                <ion-col size="6">
                  @if (filter_params['date_from'] && filter_params['date_from'].length != 0) {
                    <ion-input class="modal-input" readonly="true" label="From date" labelPlacement="stacked" fill="outline" value={{formatted_date_from}} (click)="presentFromDateTimePickerModal()"></ion-input>
                  }
                  @if (!filter_params['date_from'] || filter_params['date_from'].length == 0) {
                    <ion-input class="modal-input" readonly="true" label="From date" labelPlacement="stacked" fill="outline" (click)="presentFromDateTimePickerModal()"></ion-input>
                  }
                </ion-col>
                <ion-col size="6">
                  @if (filter_params['date_to'] && filter_params['date_to'].length != 0) {
                    <ion-input class="modal-input" readonly="true" label="To date"  labelPlacement="stacked" fill="outline" value={{formatted_date_to}} (click)="presentToDateTimePickerModal()"></ion-input>
                  }
                  @if (!filter_params['date_to'] || filter_params['date_to'].length == 0) {
                    <ion-input class="modal-input" readonly="true" label="To date" label="To date"  labelPlacement="stacked" fill="outline" (click)="presentToDateTimePickerModal()"></ion-input>
                  }
                </ion-col>
              </ion-row>
            }
            @if (registers && registers.length != 0) {
              <ion-row>
                <ion-col>
                  <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="register_options" (ionCancel)="clearRegister()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['register_id']">
                    <div slot="label">Register<ion-text class="optional">optional</ion-text></div>
                    @for (register of registers; track register) {
                      <ion-select-option value="{{register.id}}">{{register.title}}</ion-select-option>
                    }
                  </ion-select>
                </ion-col>
              </ion-row>
            }
            @if (locations && locations.length != 0) {
              <ion-row>
                <ion-col>
                  <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="location_options" (ionCancel)="clearLocation()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['location_id']">
                    <div slot="label">Location<ion-text class="optional">optional</ion-text></div>
                    @for (location of locations; track location) {
                      <ion-select-option value="{{location.id}}">{{location.title}}</ion-select-option>
                    }
                  </ion-select>
                </ion-col>
              </ion-row>
            }
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>